import React from 'react';
import type { CodeBlock } from '../../types';

export interface CodeBlockViewProps {
  block: CodeBlock;
}

export function CodeBlockView({ block }: CodeBlockViewProps): React.ReactElement {
  return (
    <pre
      data-testid="block-code"
      data-language={block.language ?? undefined}
      className="bg-surface-secondary rounded p-2 overflow-x-auto text-xs font-mono"
    >
      <code>{block.content}</code>
    </pre>
  );
}
